module.exports = __webpack_public_path__ + "img/excellentGreen.33bb3150.png";